module.exports = __webpack_public_path__ + "img/LUB00415.4c26095b.svg";